<div class="card">
  <div class="card-body">
    <div [routerLink]="['/login']" id="logo" class="mx-auto mb-4"></div>
    <h3 class="d-lg-none text-center mt-1 fw-bold">Bienvenido</h3>
    <h5 class="h5 d-lg-none text-center mt-1 mb-3 ">Sistema de agendamiento de proveedores para la minería</h5>

    <div class="text-center mb-2">Por favor ingresa tu nombre de usuario</div>
    <form class="row d-flex flex-column align-items-center mt-4" (ngSubmit)="submit()" [formGroup]="loginForm">
      <div class="col-4 p-0">
        <label for="user" class="form-label">Usuario</label>
        <div class="input-group prefix mb-3">
          <span class="
              input-group-icon
              start
              icon-login_username
              text-center text-primary
              mt-3
            " id="basic-addon3"></span>
          <input type="text" class="form-control" [ngClass]="{'ng-invalid': isError}" id="user" placeholder="Usuario"
            maxlength="20" formControlName="username" />
          <div *ngIf="invalidUsername" class="invalid-message">
            Por favor ingrese un usuario válido
          </div>
        </div>
      </div>
      <div class="col-4 d-flex flex-column p-0">
        <label for="password" class="form-label">Contraseña</label>
        <div class="input-group prefix mb-3">
          <span class="
              input-group-icon
              start
              icon-login_password_lock
              text-center text-primary
              mt-3
            "></span>
          <span (click)="showPassword = !showPassword" [ngClass]="{
              'icon-login_password_hidden': !showPassword,
              'icon-login_password_visible': showPassword
            }" class="input-group-icon end text-center text-primary mt-3"></span>
          <input [type]="showPassword ? 'text' : 'password'" class="form-control" [ngClass]="{'ng-invalid': isError}"
            id="password" placeholder="Contraseña" formControlName="contrasena" />
          <div *ngIf="invalidPassword" class="invalid-message">
            Por favor ingrese una contraseña válida
          </div>
        </div>
        <button class="btn btn-link align-self-end pt-0" type="button" (click)="showModal()">
          ¿Olvidaste tu contraseña?
        </button>
      </div>
      <div class="col-4 d-flex justify-content-center my-4">
        <div>
          <re-captcha formControlName="recaptcha" required></re-captcha>
        </div>
      </div>
      <div class="col-4 d-flex flex-column p-0">
        <button class="btn btn-primary mb-1" type="submit" [disabled]="loginForm.invalid || isLoading">
          <span *ngIf="!isLoading; else tmpLoading">Ingresar</span>
        </button>
        <div class="d-flex justify-content-center mt-4">
          <button class="btn btn-link text-start" [routerLink]="['/solicitud']">
            Solicitar un usuario
          </button>
        </div>
      </div>
    </form>
  </div>
</div>


<ng-template #tmpLoading>
  <div class="spinner-border text-white spinner-border-sm" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</ng-template>
